module.exports = ReactRedux;


//////////////////
// WEBPACK FOOTER
// external "ReactRedux"
// module id = 5
// module chunks = 0